import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    updatePaymentProfile as updatePaymentProfileApi,
    UpdatePaymentProfileApiParameter,
} from "@insite/client-framework/Services/AccountService";
import { patch } from "@insite/client-framework/Services/ApiService";
import {
    chain,
    RequestDataFromApi,
} from "@insite/client-framework/Store/Data/PaymentProfiles/Handlers/UpdatePaymentProfile";
import { AccountPaymentProfileModel } from "@insite/client-framework/Types/ApiModels";

export function storeUpdatePaymentProfile(parameter: UpdatePaymentProfileApiParameter) {
    const accountsUrl = "/api/v1/accounts";
    const paymentProfilesUrl = `${accountsUrl}/current/paymentprofiles`;
    return patch<AccountPaymentProfileModel>(
        `${paymentProfilesUrl}/${parameter.paymentProfile.id}`,
        parameter.paymentProfile,
    );
}

replaceInChain(chain, RequestDataFromApi, async props => {
    props.apiResult = await storeUpdatePaymentProfile(props.parameter);
});
